export const headerProps = {
  align: 'center',
  as: 'p',
  placement: 'plp',
  textTransform: 'none',
  weight: 'normal',
};
